import { TAccount } from '@helpers/Accounts/accounts.types';
import { getAccountIsRBL } from '@helpers/Accounts/getAccountIsRBL';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { getTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus';
import { fetchGetAccounts, fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type TFAQData = {
    loanDuration: number;
    isTopUpApproved: boolean;
    isOverdue: boolean;
    productType: TAccount['product_type'];
    isRBL: boolean;
};

export const useGetFAQData = (
    accountId: NonNullable<TAccount['account_id']>
): TFAQData => {
    const stateKey = useStateKey();

    const { data: account } = useQuery({
        queryKey: ['accounts', stateKey],
        queryFn: () => fetchGetAccounts({ stateKey }),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            ),
        suspense: true
    });

    const { data: applicationResponse } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () =>
            fetchGetApplication({
                stateKey
            }),
        suspense: true
    });
    if (!account || !applicationResponse) {
        throw new Error();
    }
    const topupStatus = getTopUpStatus(account, applicationResponse.data);

    return {
        loanDuration: getDurationInMonths(account.duration!),
        isTopUpApproved: topupStatus === 'TOPUP_APPROVED',
        isOverdue: Boolean(account.loan_status === 'overdue'),
        productType: account.product_type,
        isRBL: getAccountIsRBL(account)
    };
};
